export default "__VITE_ASSET__0a6d2f93__"